import { ApiClient } from "../config/axiosConfig";
import {
  ICreatePermission,
  IPermission,
  IPermissionResponse,
  IUpdatePermission,
} from "../models/Permission";

export const PermissionService = {
  getAllPermissions: async (): Promise<IPermission[]> => {
    const res = await ApiClient.GET<IPermission[]>("/permissions");
    return res;
  },
  createPermission: async (
    permission: ICreatePermission
  ): Promise<IPermissionResponse> => {
    const res = await ApiClient.POST<IPermissionResponse>(
      "/permissions",
      permission
    );
    return res;
  },
  updatePermission: async (
    permission: IUpdatePermission
  ): Promise<IPermissionResponse> => {
    const res = await ApiClient.PUT<IPermissionResponse>(
      `/permissions/${permission.id}`,
      permission
    );
    return res;
  },
  deletePermission: async (permissionId: number): Promise<void> => {
    const res = await ApiClient.DELETE(`/permissions/${permissionId}`);
    return res;
  },
};
